export enum AttachmentStatusTypeEnum {
	CLEAN = 'CLEAN',
    PROCESSING = 'PROCESSING',
	UNPROCESSED = 'UNPROCESSED',
    QUARANTINE = 'QUARANTINE',
}
